import { createAction } from 'redux-actions';

export const requestClientInstancesAction = createAction('REQUEST/CLIENT_INSTANCES');
export const setSearchInstanceAction = createAction('SET/ADD_SEARCH_INSTANCE');
